import React from 'react';
import {Pie, PieChart, ResponsiveContainer} from 'recharts';
import data from './data';

const StraightAnglePieChart = () => (
    <ResponsiveContainer width="100%" height={300}>
        <PieChart>
            <Pie dataKey="value" startAngle={180} endAngle={0} data={data} outerRadius={80}
                 fill="#3367d6" label />
        </PieChart>
    </ResponsiveContainer>
);

export default StraightAnglePieChart;


// WEBPACK FOOTER //
// ./app/routes/charts/routes/pie/Components/StraightAnglePieChart.js